import { Deserializable } from '../../deserializable';

export class BaseAdvancedFilterOptions implements Deserializable {
  public StartDate?: Date;
  public EndDate?: Date;
  public Propositions: string;
  public InterfaceTypes: string;
  public Team: string;
  public IsUnallocated: boolean;
  public CaseTypesSearch: string;
  public CaseTypes: string;
  public Branches: string;
  public BranchGroups: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
